import React from 'react'
import { NavLink } from 'react-router-dom'

function WhatsAppIcon() {
  return <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 11.5a8 8 0 0 1-11.8 7L4 20l1.5-4.1A8 8 0 1 1 20 11.5Z" /><path d="M9 8.5c.3-.5.7-.5 1-.1l.8 1.2c.2.3.2.6 0 .9l-.5.6c.6 1.1 1.4 1.9 2.5 2.5l.6-.5c.3-.2.6-.2.9 0l1.2.8c.4.3.4.7-.1 1-1 .7-2.1.6-3.5-.2a8.2 8.2 0 0 1-3.1-3.1c-.8-1.4-.9-2.5-.2-3.5Z" /></svg>
}

const whatsappLink = 'https://wa.me/919716234724?text=Hello%20Papreja%20Tech%20Solutions%2C%20I%20would%20like%20to%20know%20more.'

function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#071a3d] text-blue-100">
      <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-cyan-400 via-blue-500 to-cyan-300" />
      <div className="mx-auto max-w-7xl px-5 pb-8 pt-14 sm:px-8 lg:px-10">
        <div className="grid gap-10 border-b border-blue-200/15 pb-12 md:grid-cols-[1.4fr_1fr_1fr_1.2fr] md:gap-8">
          <div className="max-w-xs">
            <NavLink to="/" className="group flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-cyan-400 text-lg font-black text-[#071a3d] transition-transform group-hover:-rotate-6">
                P
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-lg font-black tracking-tight text-white">Papreja</span>
                <span className="mt-1 text-[0.65rem] font-bold uppercase tracking-[0.16em] text-cyan-300">Tech Solutions</span>
              </span>
            </NavLink>
            <p className="mt-5 text-sm leading-6 text-blue-200">
              Practical technology and thoughtful digital experiences for teams ready to move forward.
            </p>
            <div className="mt-6 flex gap-3">
              {['in', 'X', 'f'].map((social) => (
                <a
                  key={social}
                  href="#social"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-blue-200/20 text-xs font-bold text-blue-100 transition hover:border-cyan-300 hover:bg-cyan-400 hover:text-[#071a3d]"
                  aria-label={`Visit our ${social} page`}
                >
                  {social}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-sm font-bold uppercase tracking-[0.16em] text-cyan-300">Explore</h2>
            <div className="mt-5 flex flex-col items-start gap-3 text-sm">
              <NavLink to="/" className="transition hover:text-white">Home</NavLink>
              <NavLink to="/about" className="transition hover:text-white">About us</NavLink>
              <NavLink to="/services" className="transition hover:text-white">Services</NavLink>
              <NavLink to="/contact" className="transition hover:text-white">Support</NavLink>
            </div>
          </div>

          <div>
            <h2 className="text-sm font-bold uppercase tracking-[0.16em] text-cyan-300">Contact</h2>
            <div className="mt-5 space-y-3 text-sm leading-6 text-blue-200">
              <a href="mailto:info@paprejatechsolutions.com" className="block transition hover:text-white">info@paprejatechsolutions.com</a>
              <a href="tel:+919716234724" className="block transition hover:text-white">+91 9716234724</a>
              <p>Mon-Sun: 9:00 AM - 6:00 PM</p>
              <a href={whatsappLink} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-cyan-300 transition hover:text-white"><WhatsAppIcon /> Chat on WhatsApp</a>
            </div>
          </div>

          <div>
            <h2 className="text-sm font-bold uppercase tracking-[0.16em] text-cyan-300">Let&apos;s connect</h2>
            <p className="mt-5 text-sm leading-6 text-blue-200">Have a project in mind? Let&apos;s make it useful, clear, and built to last.</p>
            <NavLink
              to="/contact"
              className="mt-5 inline-flex rounded-lg bg-cyan-400 px-5 py-3 text-sm font-bold text-[#071a3d] transition hover:-translate-y-0.5 hover:bg-cyan-300"
            >
              Start a conversation <span className="ml-2" aria-hidden="true">-&gt;</span>
            </NavLink>
          </div>
        </div>

        <div className="flex flex-col gap-3 pt-6 text-xs text-blue-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Papreja Tech Solutions. All rights reserved.</p>
          <div className="flex gap-5">
            <NavLink to="/contact" className="transition hover:text-white">Privacy &amp; terms</NavLink>
          </div>
        </div>
      </div>
      <a
        href={whatsappLink}
        target="_blank"
        rel="noreferrer"
        className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-emerald-950/30 transition hover:-translate-y-1 hover:bg-[#20bd5a] sm:bottom-7 sm:right-7"
        aria-label="Chat with Papreja Tech Solutions on WhatsApp"
        title="Chat on WhatsApp"
      >
        <WhatsAppIcon />
      </a>
    </footer>
  )
}

export default Footer
